import { Box, BoxProps, Heading, Text } from "@vinomofo/components";

import { Button } from "../../button";
import { GatsbyImage } from "gatsby-plugin-image";
import { ThreeUpBannerProps } from "./ThreeUpBannerGroup";
import { justificationForTextPosition } from "./helpers";
import styled from "styled-components";

type PrimaryBannerProps = BoxProps & ThreeUpBannerProps;

const BannerLink = styled(Box)`
  width: 100%;
  text-decoration: none;
`;

const StyledButton = styled(Button)`
  font-size: 14px;
  padding: 15px 40px;
  @media ${({ theme }) => theme.mq.min.tablet} {
    && a {
      font-size: 18px;
    }
  }
`;

export const PrimaryBanner = ({
  title,
  image,
  subtitle,
  textPosition = "left",
  titleColor = "white",
  subtitleColor = "white",
  primaryCta,
  ...rest
}: PrimaryBannerProps): JSX.Element => {
  const linkTo =
    primaryCta?.linkTo?.path ||
    primaryCta?.linkTo?.url ||
    primaryCta?.linkTo?.slug;
  const target =
    primaryCta?.linkTo?.target && primaryCta?.linkTo?.target === "New Tab"
      ? "_new"
      : "_self";
  const ctaLabel = primaryCta?.label;
  return (
    <Box
      display="flex"
      alignItems="center"
      width="100%"
      height="100%"
      position="relative"
      overflow="hidden"
      py={["0px", "40px"]}
      px={["20px", "40px", "10%"]}
      minHeight={["295px", "auto"]}
      justifyContent={justificationForTextPosition[textPosition]}
      {...rest}
    >
      <a
        href={linkTo}
        target={target}
        rel="noopener"
        style={{ textDecoration: "none", zIndex: 1, width: "100%" }}
      >
        <GatsbyImage
          alt=""
          image={image}
          objectFit="cover"
          objectPosition="center center"
          style={{
            position: "absolute",
            zIndex: -1,
            top: 0,
            bottom: 0,
            right: 0,
            left: 0,
          }}
        />
        <Box width="55%">
          <Box mb="1em">
            <Heading
              variant="xl"
              fontSize={["36px", "72px"]}
              color={titleColor}
            >
              {title}
            </Heading>
          </Box>
          <Text
            fontFamily="heading"
            variant="lg"
            color={subtitleColor}
            lineHeight="tight"
          >
            {subtitle}
          </Text>
          {ctaLabel && (
            <Box mt={4}>
              <BannerLink>
                <StyledButton
                  nopadding
                  color={primaryCta.buttonTextColor || "white"}
                  backgroundColor={primaryCta.buttonColour}
                  borderColor={primaryCta.buttonColour}
                  hoverBorderColor={primaryCta.buttonHoverBorderColor}
                  hoverBackgroundColor={primaryCta.buttonHoverBackgroundColor}
                  hoverTextColor={primaryCta.buttonHoverTextColor}
                  isCTA
                >
                  {ctaLabel}
                </StyledButton>
              </BannerLink>
            </Box>
          )}
        </Box>
      </a>
    </Box>
  );
};
